import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { applicationStore } from '../../store/applicationStore';
import { iframeService } from '../iframeService';

export const PlatformMessagesWrapper = observer(({ children = [] }) => {
  const { isAuthDataReceived } = applicationStore;

  useEffect(() => {
    iframeService.setPostMessageListener();
    iframeService.sendGetAuthInfo();
  }, []);

  return isAuthDataReceived ? children : null;
});
